import React from 'react';

interface ProgressBarProps {
    value: number;
    max?: number;
    height?: 'sm' | 'md';
    colorClass?: string;
    barStyle?: React.CSSProperties;
    className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
    value,
    max = 100,
    height = 'md',
    colorClass,
    barStyle,
    className = '',
}) => {
    const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
    const containerH = height === 'sm' ? 'h-1.5' : 'h-2';
    const fillColor = colorClass ?? 'bg-theme-primary';

    return (
        <div
            className={`${containerH} w-full overflow-hidden rounded-full bg-gray-200 dark:bg-neutral-700 ${className}`}
        >
            <div
                className={`h-full rounded-full transition-all duration-300 ${fillColor}`}
                style={{ width: `${pct}%`, ...barStyle }}
            />
        </div>
    );
};

export default ProgressBar;
